import {IChangeContainer} from "src/store/actions";
import {IAppState} from "src/store/models";
import {changeBox} from "src/store/reducers/changing/changeBoxReducer";
import {addNewElement} from "src/utils/utils";

export const changeContainerReducer = (state: IAppState, action: IChangeContainer) => {
    const type = action.payload.elementId.split('__')[1];
    switch (type) {
        case 'Fruit': {
            const {elementId, targetId} = action.payload;
            const parentId = state.fruits[elementId].box;
            return {
                ...state,
                boxes: changeBox(state.boxes, elementId, parentId, targetId),
                fruits: {
                    ...state.fruits,
                    [elementId]: {
                        ...state.fruits[elementId],
                        box: targetId
                    }
                }
            };
        }
        case 'FruitBox': {
            const {elementId, targetId} = action.payload;
            const parentId = state.boxes[elementId].shelfId;
            return {
                ...state,
                boxes: {
                    ...state.boxes,
                    [elementId]: {
                        ...state.boxes[elementId],
                        shelfId: targetId
                    }
                },
                shelves: {
                    ...state.shelves,
                    [parentId]: {
                        ...state.shelves[parentId],
                        boxesIds: state.shelves[parentId].boxesIds.filter(box => box !== elementId)
                    },
                    [targetId]: {
                        ...state.shelves[targetId],
                        boxesIds: addNewElement(state.shelves[targetId].boxesIds, elementId)
                    }
                }
            };
        }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/changing/changeContainerReducer.ts